// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"962":"7378e873","990":"b593269b"}[chunkId] + ".chunk.js";
};